module.exports = __webpack_public_path__ + "static/ethan-0494ededaeafc1199fe0cf844fea2d9a.webp";